import getBrowser from './getBrowser';
import getGuid from './getGuid';

const getCommonLoginRequest = (recaptcha = false) => {
  const ipUser = getGuid();

  const loginRequest = {
    apiKey: recaptcha ? window.REACT_APP_API_KEY_CAPTCHA : window.REACT_APP_API_KEY,
    device: {
      messagingid: ipUser,
      deviceid: ipUser,
      devicename: getBrowser(),
      bloqueado: true,
      recordar: true,
    },
  };

  return loginRequest;
};

export default getCommonLoginRequest;
